import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1072.94118,113 C1540.06588,113 1920,492.934118 1920,960.058824 C1920,1427.18353 1540.06588,1807.11765 1072.94118,1807.11765 C816.790588,1807.11765 577.694118,1693.27294 416.865882,1494.83529 L416.865882,1494.83529 L504.734118,1423.68235 C643.990588,1595.57882 851.011765,1694.17647 1072.94118,1694.17647 C1477.72235,1694.17647 1807.05882,1364.84 1807.05882,960.058824 C1807.05882,555.277647 1477.72235,225.941176 1072.94118,225.941176 C851.011765,225.941176 643.990588,324.538824 504.734118,496.435294 L504.734118,496.435294 L416.865882,425.282353 C577.694118,226.844706 816.790588,113 1072.94118,113 Z M943.442824,524.885176 L1378.60518,960.047529 L943.442824,1395.20988 L863.593412,1315.47341 L1162.54871,1016.51812 L0.0451764706,1016.51812 L0.0451764706,903.576941 L1162.54871,903.576941 L863.593412,604.734588 L943.442824,524.885176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconToggleRightLine = /*#__PURE__*/function (_Component) {
  _inherits(IconToggleRightLine, _Component);

  var _super = _createSuper(IconToggleRightLine);

  function IconToggleRightLine() {
    _classCallCheck(this, IconToggleRightLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconToggleRightLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconToggleRight",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconToggleRightLine.displayName = "IconToggleRightLine";
  return IconToggleRightLine;
}(Component);

IconToggleRightLine.glyphName = 'toggle-right';
IconToggleRightLine.variant = 'Line';
IconToggleRightLine.deprecated = true;
IconToggleRightLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconToggleRightLine;
export { IconToggleRightLine };